import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";

// Public Pages
import BlogHub from "@/pages/BlogHub";
import ArticlePage from "@/pages/ArticlePage";
import SeriesHub from "@/pages/SeriesHub";

// Admin Pages
import AdminLogin from "@/pages/admin/AdminLogin";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import AdminArticles from "@/pages/admin/AdminArticles";
import AdminArticleEdit from "@/pages/admin/AdminArticleEdit";
import AdminCategories from "@/pages/admin/AdminCategories";
import AdminNewsletter from "@/pages/admin/AdminNewsletter";

// Auth Provider
import { AuthProvider, useAuth } from "@/contexts/AuthContext";

// Protected Route Component
const ProtectedRoute = ({ children }) => {
  const { isAuthenticated, loading } = useAuth();
  
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#F8F9FA]">
        <div className="text-center">
          <div className="w-8 h-8 border-2 border-[#9D6E6D] border-t-transparent rounded-full animate-spin mx-auto mb-4"></div>
          <p className="font-label text-sm text-[#767C91]">Loading...</p>
        </div>
      </div>
    );
  }
  
  if (!isAuthenticated) {
    return <Navigate to="/admin" replace />;
  }
  
  return children;
};

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster position="top-right" />
        <Routes>
          {/* Redirect root to blog */}
          <Route path="/" element={<Navigate to="/en/blog" replace />} />
          
          {/* Public Blog Routes */}
          <Route path="/en/blog" element={<BlogHub />} />
          <Route path="/en/blog/:slug" element={<ArticlePage />} />
          <Route path="/en/blog/women-who-changed-the-rules" element={<SeriesHub />} />
          
          {/* Admin Routes */}
          <Route path="/admin" element={<AdminLogin />} />
          <Route path="/admin/dashboard" element={
            <ProtectedRoute>
              <AdminDashboard />
            </ProtectedRoute>
          } />
          <Route path="/admin/articles" element={
            <ProtectedRoute>
              <AdminArticles />
            </ProtectedRoute>
          } />
          <Route path="/admin/articles/new" element={
            <ProtectedRoute>
              <AdminArticleEdit />
            </ProtectedRoute>
          } />
          <Route path="/admin/articles/edit/:id" element={
            <ProtectedRoute>
              <AdminArticleEdit />
            </ProtectedRoute>
          } />
          <Route path="/admin/categories" element={
            <ProtectedRoute>
              <AdminCategories />
            </ProtectedRoute>
          } />
          <Route path="/admin/newsletter" element={
            <ProtectedRoute>
              <AdminNewsletter />
            </ProtectedRoute>
          } />
          
          {/* Catch all */}
          <Route path="*" element={<Navigate to="/en/blog" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
